/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ round: NonNullable<unknown>, table: NonNullable<unknown> }} Tournament_Round_TableInputs */



/**
* | output |
* | --- |
* | "Round {round} — {table}" |
*
* @param {Tournament_Round_TableInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_round_table = /** @type {((inputs: Tournament_Round_TableInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_Round_TableInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Ronde ${i?.round} — ${i?.table}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Ronda ${i?.round} — ${i?.table}`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`Rodada ${i?.round} — ${i?.table}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Round ${i?.round} — ${i?.table}`)
	return /** @type {LocalizedString} */ (`Round ${i?.round} — ${i?.table}`)
});